import { Users } from 'lucide-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import GroupCard from './GroupCard';
import Pagination from '../common/Pagination';
import Loader from '../common/Loader';
import GroupApplicationModal from '../modals/GroupApplicationModal';
import { paginate } from '../../utils/helpers';

const GroupGrid = ({ groups, loading, isAdmin = false, itemsPerPage = 12 }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { t } = useTranslation();

  const handleJoin = (group) => {
    setSelectedGroup(group);
    setIsModalOpen(true);
  };

  if (loading) {
    return (
      <div className="flex justify-center py-12">
        <Loader size="lg" text={t('lists.loading_groups')} />
      </div>
    );
  }

  if (!groups || groups.length === 0) {
    return (
      <div className="text-center py-12">
        <Users className="h-16 w-16 text-gray-400 mx-auto mb-4" />
        <p className="text-gray-600 dark:text-gray-400 text-lg mb-2">
          {t('lists.no_groups')}
        </p>
        <p className="text-gray-500 dark:text-gray-500 text-sm">
          {t('lists.no_groups_desc')}
        </p>
      </div>
    );
  }

  const paginatedData = paginate(groups, currentPage, itemsPerPage);

  return (
    <div>
      {/* Groups Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
        {paginatedData.data.map((group) => (
          <GroupCard
            key={group.id}
            group={group}
            isAdmin={isAdmin}
            onJoin={handleJoin}
          />
        ))}
      </div>

      {/* Pagination */}
      {paginatedData.totalPages > 1 && (
        <Pagination
          currentPage={currentPage}
          totalPages={paginatedData.totalPages}
          onPageChange={setCurrentPage}
        />
      )}

      {/* Results Info */}
      <div className="text-center mt-4 text-sm text-gray-600 dark:text-gray-400">
        {t('lists.showing_results', {
          start: (currentPage - 1) * itemsPerPage + 1,
          end: Math.min(currentPage * itemsPerPage, groups.length),
          total: groups.length
        })} {t('lists.items_groups')}
      </div>

      {/* Join Modal */}
      <GroupApplicationModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        group={selectedGroup}
      />
    </div>
  );
};

export default GroupGrid;
